export default function(buttonAdjustment) {
    if (window.innerWidth <= 768) {
        if($('.bottomBtn').offset()) {
            const bottomButtonNeedsAdjusting = $('.bottomBtn').offset().top < window.innerHeight && window.innerHeight - $('.bottomBtn').offset().top > 50
            if (bottomButtonNeedsAdjusting){
                var newHeight = window.innerHeight - $('.bottomBtn').offset().top;
                $('.bottomBtnDiv').css('height', newHeight + buttonAdjustment);
                $('.bottomBtn').addClass('bottomBtnScroll');
            } else {
                $('.bottomBtnDiv').css('margin-bottom', '50px');
                $('.bottomBtn').removeClass('bottomBtnScroll');
            }
            $('.bottomBtn').css('opacity', 1);
        }
    }
}
